export default __webpack_public_path__ + "static/media/toolbar-hyperlink.cb9c6dc7.svg";